import enquire from 'enquire.js';
import breakpoints from '../data/breakpoints';
import $ from 'jquery';

class Listing {
    constructor(el) {
        this.el = el;

        this.columns = [];

        this.listingEl = el;
        this.listingTableEl = this.listingEl.find('.listing__table');

        this.listingConfig = this.listingEl.data('config');
        if (this.listingConfig) {
            this.columns = this.listingConfig.columns;
        }
        else {
            this.listingConfig = {
                responsive: {}
            };
        }

        const _this = this;

        this.columns.forEach((columnKey) => {
            const column = this.getColumnByKey(columnKey);
            this.listingTableEl
                .find(`> tbody > tr > td:nth-child(${column + 1})`)
                .attr('data-column', columnKey);
        });

        // Create stack columns
        this.listingTableEl.find('> tbody > tr').each((i, row) => {
            row = $(row);
            $(
                `<td class="stack">
          <table>

          </table>
        </td>`).appendTo(row);
        });

        enquire.register(breakpoints.query.mobile, {
            match: () => {
                _this.handleBreakpoint('mobile');
            }
        });
        enquire.register(breakpoints.query.tablet, {
            match: () => {
                _this.handleBreakpoint('tablet');
            }
        });
        enquire.register(breakpoints.query.desktop, {
            match: () => {
                _this.handleBreakpoint('desktop');
            }
        });
    }

    handleBreakpoint(breakpoint) {
        const config = this.getResponsiveConfig(breakpoint);

        const hide = config.hide || [];
        let stack = config.stack || [];
        if (stack === 'all') {
            stack = [...this.columns];
        }

        const show = this.columns.filter(column => !hide.includes(column));

        this.stackColumns(stack);
        this.hideColumns(hide);
        this.showColumns(show);
    }

    getResponsiveConfig(breakpoint) {
        return this.listingConfig.responsive[breakpoint] || {};
    }

    getColumnByKey(key) {
        return this.columns.indexOf(key);
    }


    stackColumns(columnKeys) {
        this.listingTableEl.find('tr').each((i, row) => {
            row = $(row);

            let stackColumn = row.find('td.stack');
            if (stackColumn.length === 0) {
                stackColumn = $(
                    `<td class="stack">
            <table>

            </table>
          </td>`).appendTo(row);
            }
            let stackColumnTable = stackColumn.find('table');
            stackColumnTable.html('');
            row.find('> td').removeClass('stacked');
            columnKeys.forEach((columnKey) => {
                let columnEl = row.find(`> td[data-column="${columnKey}"]`);
                columnEl.clone().appendTo(stackColumnTable);
                columnEl.addClass('stacked');
            });


        });


    }
    hideColumns(columnKeys) {
        columnKeys.forEach((columnKey) => {
            this.listingTableEl.find(`td[data-column="${columnKey}"]`).addClass('hidden');
        });
    }

    showColumns(columnKeys) {
        columnKeys.forEach((columnKey) => {
            this.listingTableEl.find(`td[data-column="${columnKey}"]`).removeClass('hidden');
        });
    }
}

export default Listing;